module.exports = __webpack_public_path__ + "resource/img/sun-toggle.ecab8963.svg";